<template>
  <carousel :autoplay="true" :nav="false" :items="1" v-if="slides.length">
    <div
      v-for="(slide, index) in slides"
      :key="index"
      class="slider-item position-relative"
    >
      <a :href="slide.link" target="_blank"></a>
      <img :src="slide.img" :alt="index" />
    </div>
  </carousel>
</template>

<script>
import axios from "axios";
import carousel from "vue-owl-carousel";

export default {
  name: "Slides",
  components: { carousel },
  data() {
    return {
      slides: "",
    };
  },
  methods: {
    getSlides() {
      axios
        .get(process.env.VUE_APP_URL_PORTAL + "/wp-json/arta/slides", {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TOKEN_PORTAL}`,
          },
        })
        .then((response) => {
          this.slides = response.data.slides;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.msg,
            type: "error",
          });
        });
    },
  },

  created() {
    this.getSlides();
  },
};
</script>

<style lang="scss" scoped>
.card {
  transition: all 0.2s;
  &:hover {
    transform: translateY(-10px);
  }
}
.slider-item {
  a {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
}
</style>
